export enum Platform {
    Mobile = 'Mobile',
    Desktop = 'Desktop',
}

export enum ComponentType {
    Carousel = 'Carousel',
    Waterfall = 'Waterfall',
}
